export const START_GAME = 'START_GAME';
export const START_LEVEL = 'START_LEVEL';
export const RESET_GAME = 'RESET_GAME';
export const CHECK_CHAR = 'CHECK_CHAR';
export const NEXT_LEVEL = 'NEXT_LEVEL';
export const FINAL_ANSWER = 'FINAL_ANSWER';

export const DEFAULT_LIFE = 10;
export const ALL_CHARS = ['А', 'Б', 'В', 'Г', 'Д', 'Е', 'Ж', 'З', 'И', 'К', 'Л', 'М', 'Н', 'О', 'П', 'Р', 'С', 'Т', 'У', 'Ф', 'Х', 'Ц', 'Ч', 'Ш', 'Ы', 'Э', 'Ю', 'Я'];

export const ROUTE_START = 'ROUTE_START';
export const ROUTE_GAME = 'ROUTE_GAME';
export const ROUTE_ANSWER = 'ROUTE_ANSWER';
export const ROUTE_LAST_ANSWER = 'ROUTE_LAST_ANSWER';
export const ROUTE_END = 'ROUTE_END';
export const ROUTE_WIN = 'ROUTE_WIN';
